import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Ticket } from 'images/latest'

const TicketIcon = () => (
  <ResponsiveSVG
    width={['56px', null, '56px']}
    className='unstyled'
    svgProps={{ viewBox: '0 0 56 56' }}
    SVG={Ticket}
  />
)

export default TicketIcon
